import React, { useEffect, useState } from "react";

export default function MidnightTimer() {
  const [midCountdown, setMidCountdown] = useState("...");

  useEffect(() => {
    function updateCountdown() {
      const now = new Date();

      const nextMidnightUTC = new Date(Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate() + 1,  // Next day
        0, 0, 0                // 00:00:00 UTC
      ));

      const diffMS = nextMidnightUTC - now;

      const totalSeconds = Math.floor(diffMS / 1000);
      const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
      const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, "0");
      const seconds = String(totalSeconds % 60).padStart(2, "0");

      setMidCountdown(`${hours}:${minutes}:${seconds}`);
    }

    // Start immediately
    updateCountdown();

    const intervalId = setInterval(updateCountdown, 1000);

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, []);

  return (
    <p className="result-text next-junglejumble-timer">
      Next Jungle Jumble in {midCountdown}
    </p>
  );
}